module.exports = __webpack_public_path__ + "img/013-logo.04cb66ed.png";